var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-title-back",class:`main-title-back_size-${_vm.size}`},[_c('button-redirect',{staticClass:"main-title-back__button-redirect",attrs:{"text":_vm.buttonText},on:{"click":function($event){return _vm.$router.push({ name: _vm.href })}}}),_c('h1',{staticClass:"main-title-back__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }